import {Injectable} from '@angular/core';
import {IFilterTypes} from '../interfaces/filters.interface';

@Injectable({
  providedIn: 'root',
})
export class FilterService {
  filterTypes: IFilterTypes = {
    status: 'dropdown',
    employmentForm: 'dropdown',
    departments: 'dropdown',
    gender: 'checkbox',
    position: 'input',
    level: 'checkbox',
    projectManager: 'input',
    deliveryManager: 'checkbox',
    unit: 'checkbox',
    projects: 'input',
    assignedHr: 'input',
    assignedMentor: 'input',
    probationEndDate: 'date',
    probationEndStatus: 'checkbox',
    personalData: 'checkbox',
    techStack: 'input',
    framework: 'input',
    techInterviewStatus: 'checkbox',
    techInterviewDate: 'date',
    englishLevel: 'checkbox',
    englishCourses: 'checkbox',
    securityTraining: 'checkbox',
    internalCourses: 'checkbox',
    conference: 'checkbox',
    certifications: 'checkbox',
    presentation: 'checkbox',
    isAMentor: 'checkbox',
    performanceReviewInThePeriod: 'doubleDate',
    promotionInThePeriod: 'doubleDate',
  };
}
